import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
export default {
  init() {
    window.goTo = function(data) {
      window.location = data.getAttribute('value')
    }

    let intro = document.querySelector('.intro p')
    let thumb = document.querySelectorAll('.thumb')

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.companies-wrap',
        start: 'top center',
      },
    })
    tl.to(intro, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
    .to(thumb, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.6}}, '-=1')

     // Popout

     $('.thumb .overlay').on('click', function(event) {
      let current = $(this).data('open');
      $('#'+current).addClass('active');
      $('.popout-ol').addClass('active');
      $('body').addClass('locked');
      $('.popout').not($('#'+current)).removeClass('active');
      $('.popslider').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,
        centerMode: true,
        variableWidth: true,
        nextArrow:"<button type='button' class='slick-next'></button>",
        prevArrow:"<button type='button' class='slick-prev'></button>",
      });
      $('.popslider').slick('refresh');
      event.preventDefault();
    });

     $('.close-popout').on('click', function(event) {
       $(this).parent().removeClass('active');
       $('.popout-ol').removeClass('active');
       $('body').removeClass('locked');
       event.preventDefault();
     });

     $('.popout-ol').on('click', function() {
       $('.popout').removeClass('active');
       $('.popout-ol').removeClass('active');
       $('body').removeClass('locked');
     });
   },
   finalize() {
   },
 };



// WEBPACK FOOTER //
// ./scripts/routes/taxMi_types.js